import { ChangeDetectionStrategy, Component, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';

const STORAGE_KEY = 'cookieConsent';

@Component({
  selector: 'sens-cookie-consent',
  imports: [RouterLink],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CookieConsentComponent {
  private platformId = inject(PLATFORM_ID);

  visible = signal(this.isInitiallyVisible());

  private isInitiallyVisible(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    try {
      return !localStorage.getItem(STORAGE_KEY);
    } catch {
      return false;
    }
  }

  accept(): void {
    this.persist('accept');
  }

  decline(): void {
    this.persist('decline');
  }

  private persist(value: 'accept' | 'decline'): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.setItem(STORAGE_KEY, value);
      } catch {
      }
    }
    this.visible.set(false);
  }
}
